import React, { Component } from 'react';

export default class salesInformationCellRenderer extends Component {
  constructor(props) {
    super(props);
  }

  setFormatterDate(value) {
    const newDate = new Date(value);

    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0');
    const year = newDate.getFullYear();

    return `${day}/${month}/${year}`;
  }

  renderDestination(arrayDestinations) {
    let formatArray = [];
    if (arrayDestinations && arrayDestinations.length > 0) {
      formatArray = arrayDestinations.map((destination) => {
        const dateInitial = this.setFormatterDate(destination.departureDate);
        const dateFinal = this.setFormatterDate(destination.returnDate);

        return `${dateInitial} - ${dateFinal} - ${destination.destination}`;
      });
    }

    //return formatArray.join(', ');
    if (formatArray.length > 0) {
      return <div style={{ marginBottom: '2px' }}>{formatArray[0]}</div>;
    }
    /*return formatArray.map((dest, index) => (
      <div key={index} style={{ marginBottom: '2px' }}>
        {dest}
      </div>
    ));*/
  }

  render() {
    return (
      <div
        style={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          lineHeight: '1.3',
          padding: '4px',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        {this.renderDestination(this.props.value)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CellRenderer/salesInformationCellRenderer.jsx